import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
// import Button from '../components/buttons_refactor/Button';
import ServicePages from '../components/services/ServicePages';
import ServiceCarousel, { slides } from '../components/ServiceCarousel';
import useBreakpoints from '../hooks/useBreakPoint';

const Services = () => {
  const { slug } = useParams();
  const { isMd, isLg, is2xl, is3xl } = useBreakpoints();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, [slug]);

  return (
    <div id="services">
      <Header />
      <div
        className={`bg-cover no-repeat w-100% h-148 md:h-70 lg:h-88 2xl:h-114 3xl:h-152 ${ServicePages[slug].bgImage} ${ServicePages[slug].bgColor}`}
        style={{ backgroundBlendMode: 'multiply' }}
      >
        <div>
          <div className="pl-8 pt-72 md:pl-20 md:pt-20 lg:pl-24 lg:pt-32 2xl:pl-36 2xl:pt-41.5 3xl:pl-48">
            <img
              src={ServicePages[slug].icon}
              alt={ServicePages[slug].title}
              className="h-12 mb-5 md:mb-6 lg:h-16 2xl:mb-8 3xl:h-24 3xl:mb-12"
            />
            <div className="text-white font-montserrat font-bold uppercase text-3.5xl leading-10 left-align h-20 w-80 md:w-110 lg:w-192 lg:text-4.3xl lg:h-28 lg:leading-12 2xl:text-6xl 2xl:h-36 2xl:w-192 2xl:leading-16 3xl:text-7.6xl 3xl:h-48 3xl:w-192 3xl:leading-24">
              {ServicePages[slug].title}
            </div>
          </div>
          <div className="pl-8 pt-16 md:pl-128 md:pt-8 lg:pl-180 lg:pt-1 2xl:pl-290 2xl:pt-4 3xl:pl-372 3xl:pt-18">
            {/* <Button tag="modal" appearance="secondary" className="md:shadow-xl">
              Request A Quote
            </Button> */}
          </div>
        </div>
      </div>
      <div className="flex pb-4">
        <p className="flex-grow text-techsicoGray-400 font-montserrat text-base left-align whitespace-pre-line mx-8 mr-8 ml-8 mt-9 mb-8 w-80 md:mt-14 md:w-88 md:ml-20 lg:mt-20 lg:w-124 lg:ml-24 lg:text-xl 2xl:mt-24 2xl:w-176 2xl:ml-36 2xl:text-2xl 3xl:w-208 3xl:ml-48">
          {ServicePages[slug].content}
        </p>
        <div className="md:ml-3 md:mr-16 lg:ml-4 lg:mr-24 2xl:ml-16 2xl:mr-36 3xl:ml-24 3xl:mr-48">
          <img
            src={ServicePages[slug].topImage}
            alt="top"
            className="hidden md:block mt-14 w-60 rounded-2xl lg:mt-20 lg:w-72 2xl:mt-24 2xl:w-118 3xl:w-148"
          />
          {ServicePages[slug].bottomImage && <img
            src={ServicePages[slug].bottomImage}
            alt="bottom"
            className="hidden md:block my-8 w-60 h-36 rounded-2xl md:mb-64 lg:w-72 lg:h-42 lg:mb-88 2xl:w-118 2xl:h-68 2xl:mb-72 3xl:w-148 3xl:h-88 3xl:mb-80"
          />}
        </div>
      </div>
      {/* insert Contact Us For More Information here */}
      {/* insert Carousel here */}
      <ServiceCarousel
        // arrowPlacement="topLeft"
        autoplay={false}
        slidesToShow={isMd ? 6 : 2}
        height={is2xl ? 'h-60' : isMd ? 'h-36' : 'h-40'}
      >
        {slides
          .filter(slide => slide.slug !== slug)
          .map(
            ({
              id,
              title,
              icon,
              bgImage,
              bgColor,
              bgOpacity,
              slug: serviceSlug,
              iconClassName,
            }) => (
              <Link
                to={`/services/${serviceSlug}`}
                key={id}
                className={is2xl ? 'h-60' : isMd ? 'h-36' : 'h-40'}
              >
                <div
                  className={`relative bg-center bg-cover bg-no-repeat bg-blend-multiply h-full ${bgColor} ${bgOpacity} ${
                    is3xl
                      ? `${bgImage['3xl']}`
                      : is2xl
                      ? `${bgImage['2xl']}`
                      : isLg
                      ? `${bgImage.lg}`
                      : isMd
                      ? `${bgImage.md}`
                      : `${bgImage.xs}`
                  }`}
                >
                  <img
                    src={icon}
                    alt={title}
                    className={`${iconClassName} absolute top-4 ${
                      is3xl
                        ? 'top-8 left-8'
                        : is2xl
                        ? 'top-6 left-6'
                        : isMd
                        ? 'left-6'
                        : 'left-3'
                    }`}
                  />

                  <h2
                    className={`absolute text-white font-montserrat font-bold  ${
                      is3xl
                        ? 'text-3.5xl leading-10 bottom-8 left-8'
                        : is2xl
                        ? 'text-2xl leading-7 bottom-7 left-6'
                        : isLg
                        ? 'text-base leading-5 bottom-4 left-6'
                        : isMd
                        ? 'text-sm bottom-3 left-3'
                        : 'text-base leading-5 bottom-4 left-3'
                    }`}
                  >
                    {title.split('\n').map((line, i) => (
                      <span key={i} className="block">
                        {line}
                      </span>
                    ))}
                  </h2>
                </div>
              </Link>
            ),
          )}
      </ServiceCarousel>
    </div>
  );
};

export default Services;
